<template>
  <!-- 分割线组件
      @author: 王汝鹏
      @date: 2019-9-20
  -->
  <div class="form-item_line"
       :style="{'padding-left': paddingLeft}">
    <div class="line-wrapper" :style="{justifyContent: textPosition}">
      <span class="text" >{{lineText}}</span>
      <div class=line :style="{borderStyle: lineStyle, width}"></div>
    </div>
  </div>
</template>
<script>
/** 混入方法 ::: 
 *  @mixin mixFormItemTemplateChild 表单项子级混入
 */
import { mixFormItemTemplateChild } from "@/mixins/form_item/mix_form_item_template_child.js";


export default {
  mixins: [ mixFormItemTemplateChild ]
}
</script>


// WEBPACK FOOTER //
// src/components/form_item/FormItemLine.vue